import React from "react";
import { Grid } from "@material-ui/core";
import { InputTextMaster, InputOptionMaster } from "App/Component/ui";
import { useSelectOption } from "App/hooks";
import { TYPE_INSTANCE2 } from "App/constants";
import { messageError } from "utils/all";

export default function FormPenanggung({ formData, handleChange }) {
  const listGuarantorConn = useSelectOption(
    false,
    "/atribut/atr_ms_guarantor_connection/list_prm",
    TYPE_INSTANCE2
  );
  return (
    <>
      <p className='fw-600 mt-2'>PENANGGUNG</p>
      <div className='mt-1'>
        <Grid container spacing={1}>
          <Grid item xs={6} sm={4}>
            <InputOptionMaster
              name='penanggung'
              label='PENANGGUNG'
              id='penanggung'
              onChange={handleChange("guarantor_connection")}
              needParse={false}
              value={formData.guarantor_connection}
              data={listGuarantorConn}
              error={true}
              message={messageError.required}
            />
          </Grid>
          <Grid item xs={6} sm={4}>
            <InputTextMaster
              name='nama_penanggung'
              label='NAMA PENANGGUNG'
              id='nama_penanggung'
              placeholder='-'
              value={formData.guarantor_name}
              onChange={handleChange("guarantor_name")}
              error={true}
              message={messageError.required}
            />
          </Grid>
        </Grid>
      </div>
    </>
  );
}
